<a (click)='this.onBtnClicked()' [tooltip]="this.showTooltip? ('PUZZLE.custom_button.' + (this.customID - 1) | translate) : ''">
<!--  <mat-icon *ngIf="this.showIcon">{{this.icon}}</mat-icon><img class="button-image" [hidden]="!this.showImage" [src]='this.image'/>-->
  {{this.name}}
</a>
